import { render, staticRenderFns } from "./QuestionTypeGlue.vue?vue&type=template&id=c1e03976&"
import script from "./QuestionTypeGlue.vue?vue&type=script&lang=js&"
export * from "./QuestionTypeGlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports